/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
export default {
  STUDENT_LEAVED_CLASS(state, id) {
    const index = state.students.findIndex((u) => u.id === id);
    state.students.splice(index, 1);
  },
};
